export default function Button({ children, onClick, className }: any) {
  return (
    <button
      onClick={onClick}
      className={`${className} py-3 px-4 rounded bg-orange-500 text-white uppercase min-w-60`}
    >
      {children}
    </button>
  );
}
